import { useQuery } from 'react-query'

import { API } from '../lib/amplify'

export const useVendorSalesPerson = (campaignId: number) => {
  return useQuery(['vendor-sales-person'], async () => {
    return await API.get('client', `/vendor-sales-person/${campaignId}`, {})
  })
}
